import { convertMinutesToHours } from '@nile/mangifera/src/Utils/helpers';
import { Timer } from '@styled-icons/remix-fill';
import React from 'react';
import { DisabledTag } from '@nile/components';
import { renderTime } from '@nile/projects/src/Utils';

function TimerCell(props) {
  const { cell } = props;
  let value = cell.value;
  if (value && value > 0) {
    value = convertMinutesToHours(value);
  }
  if (value === null) value = '--';
  const displayVal = renderTime(cell?.value);
  return (
    <div className="ellipsis" title={displayVal}>
      {displayVal || <DisabledTag>NA</DisabledTag>}
    </div>
  );
}

export default TimerCell;
